<template>
  <l-container class="mt-4">    
    <apexchart
      width="100%"
      height="300"
      :options="options"
      :series="[]"
    ></apexchart>
  </l-container>
</template>


<script>
import * as moment from "moment";
import ApexchartHelper from "@/helpers/settings/apexchart";
import VueApexCharts from "vue-apexcharts";
import ApexCharts from "apexcharts";

export default {
  name: "LLChart",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      hasData: false,
      options: ApexchartHelper.settings(),
    };
  },
  methods: {
    removeSeries() {      
      
    },
    addSeries(series) {                  
      ApexCharts.exec("apexchart", "updateSeries", series, false); // Avoid slow vue observable object            
    }
  }
};
</script>
